import DOMPurify from "dompurify";

const PURIFY_OPTS = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ["target"], // allow target="_blank" on links from CMS
};

/**
 * Sanitize HTML before using with dangerouslySetInnerHTML.
 */
export function sanitizeHtml(dirty) {
  if (!dirty || typeof dirty !== "string") return "";
  return DOMPurify.sanitize(dirty, PURIFY_OPTS);
}

/**
 * Escape text for inserting into HTML (plain-text CMS bodies).
 */
function escapeHtml(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Heuristic: string looks like HTML from the API (tags from CMS / admin).
 */
function looksLikeHtml(str) {
  return /<\/?[a-z][\s\S]*>/i.test(str.trim());
}

/**
 * Normalize API `body` field: HTML from CMS is sanitized; plain text becomes paragraphs.
 */
export function formatCmsBodyForDisplay(raw) {
  if (!raw || typeof raw !== "string") return "";
  const trimmed = raw.trim();
  if (!trimmed) return "";

  if (looksLikeHtml(trimmed)) {
    return sanitizeHtml(trimmed);
  }

  const escaped = escapeHtml(trimmed);
  const paragraphs = escaped
    .split(/\n\s*\n/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => {
      const withBreaks = block.replace(/\n/g, "<br />");
      return `<p>${withBreaks}</p>`;
    })
    .join("");

  return sanitizeHtml(paragraphs || `<p>${escaped}</p>`);
}
